import React from 'react'

const Cart = () => {
  return (
    <div>This is cart page</div>
  )
}

export default Cart